import PdfViewer from './PdfViewer';

export { PdfViewer };
export default PdfViewer;
